import { createSlice } from '@reduxjs/toolkit';
import { createApi } from '../../utils/api';

export const getHeaderRoles = createApi(`GetHeaderRolesSlice`,"GET");

const GetHeaderRolesSlice = createSlice({
  name: 'GetHeaderRolesSlice',
  initialState: {
    data: [],
    loading: false,
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getHeaderRoles.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(getHeaderRoles.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload;
      })
      .addCase(getHeaderRoles.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
  },
});

export default GetHeaderRolesSlice.reducer;